//
//
//
//
//
//
//

export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.gotoAction(to.query.confirm);
    })
    
  },
  head() {
    return {
      title: 'Webcamsex | ' + process.env.APP_TITLE,
      meta: [
      { hid: 'robots', name: 'robots', content: 'noindex' }
      ]
    }
  },
  data() {
    return {
      mobile: this.$config.webcamUrlMobile + 'betalen?m=' + this.$route.params.slug + '&p=' + this.$config.webcamP + '&pi=' + this.$config.webcamName + '_vod',
      desktop: this.$config.webcamUrl + '/' + this.$config.webcamName + '/?m=' + this.$route.params.slug + '&p=' + this.$config.webcamP + '&pi=' + this.$config.webcamName + '_vod'
    }
  },
  methods: {
      gotoAction: function(choice) {
        window.location.href = this.desktop;
      },
  }
}
